/**
 * Created by JackCui on 2022/6/30
 */

export default {
  computed: {
    menuApiName () {
      const {c} = this.$route.query
      if (c) {
        try {
          const {objectApiName} = this.params
          const {menuParams} = JSON.parse(c || '{}')
          if (menuParams?.objectApiName === objectApiName) {
            return menuParams.menuApiName
          }
        } catch (e) {
        }
      }
      return ''
    }
  }
}